import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requirePlan = null }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      // Use window.location.replace to avoid DataCloneError on Safari/iOS.
      // React Router navigate() with state triggers structuredClone on the History API
      // which fails on Safari when existing history state contains non-cloneable objects.
      const from = encodeURIComponent(location.pathname);
      window.location.replace(`/login?from=${from}`);
      return;
    }
    if (requirePlan === 'recon' && !['recon', 'intelligence'].includes(user.subscription_plan)) {
      navigate('/pricing');
    }
    if (requirePlan === 'intelligence' && user.subscription_plan !== 'intelligence') {
      navigate('/pricing');
    }
  }, [user, loading, navigate, location, requirePlan]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-foreground border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return null;
  return children;
};

export default ProtectedRoute;
